<div id="utf-unauth-page-container">
  <div class="row no-gutters">
    <div class="col-lg-4">
      <app-progress-tracker [stepOneIcon]="stepOneIcon" [stepOneTickIcon]="stepOneTickIcon" [stepOneDone]="stepOneDone"
        [stepTwoInformationpage]="stepTwoInformationpage" [stepTwoProfileDone]="stepTwoProfileDone"
        [stepTwoDone]="stepTwoDone" [progressTrackerStatus]="progressTrackerStatus"
        (progressTrackerEvent)="handleProgressTrackerEvent($event)"></app-progress-tracker>
    </div>
    <div class="col-lg-8" id="form-component-section">
      <app-utf-unauth-page-form></app-utf-unauth-page-form>
    </div>
  </div>
</div>